import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Network } from '@ionic-native/network';
import { StubService } from './../stub-service/stub.service';
import { Sample } from './../../models/sample';
import { Log } from './../../models/log';
import { Project } from './../../models/project';
import { Events } from 'ionic-angular';
import { ENV } from '@app/env';
import { AuthServiceProvider } from '../auth-service/auth-service';
import { EnvService } from './../env-friendly-service/env-friendly-service';

var sessionID = window.localStorage.getItem('session') || '';
import * as _ from 'lodash';

// Rows per round when resolving the newest log per sample. Capped by
// handleHighCountsForEndpoints(); passed explicitly so it does not fall through to the
// default and log a "was not passed a count value" warning on every page load.
const LATEST_LOG_ROWS_PER_ROUND = 250;
// Safety cap on the unseen-set loop. Each round resolves at least the sample owning the
// newest remaining log, so a page of N samples needs at most N rounds and in practice one.
// Hitting the cap is not an error: unresolved samples keep their seeded fallback date.
const LATEST_LOG_MAX_ROUNDS = 5;

var _Settings = {
    Server: ENV.API_URL,
    // the name of the entity
    Entity: null,
    DebugLog: false,
    // Whether to cache this request
    Cached: false,
    Headers: {},
    DataModel: {}
};

// Sync between Server

/*
  Generated class for the SyncServerServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
 */
@Injectable()
export class SyncServerServiceProvider {
    syncLogsTime;
    syncSamplesTime;
    syncProjectsTime;
    syncPlantsTime;
    latestUpdateDate_Sample = null;
    latestUpdateDate_Log = null;
    db;

    entitySample;
    entityLog;

    constructor(
        public events: Events,
        private network: Network,
        public http: HttpClient,
        private authService: AuthServiceProvider,
        private stub: StubService,
        public envService: EnvService
    ) {
        console.log('Hello SyncServerServiceProvider Provider');

        events.subscribe('user:loggedIn', () => {
            var env = window.localStorage.getItem('env');
            console.log('setting server to', env);
            _Settings.Server = this.envService.getAppUrl();
            console.log('------- event triggered: user:loggedIn === from sync service');
            sessionID = window.localStorage.getItem('session') || '';
        });
        events.subscribe('user:loggedOut', () => {
            sessionID = undefined;
        });
    }

reloadURL() {
        this.stub.targetURL = this.envService.getAppUrl();
    }

    async prepareSettings() {
        // await headlight extended model
        _Settings.Server = this.envService.getAppUrl();
        if (!sessionID) {
            let isLoggedIn = await this.authService.checkSession();
            if (isLoggedIn['SessionID']) {
                sessionID = isLoggedIn['SessionID'];
                window.localStorage.setItem('session', isLoggedIn['SessionID']);
            } else {
                console.log('not logged in?');
            }
        }
        return _Settings;
    }

    handleHighCountsForEndpoints(count, methodName, customLimit?) {
        let pageLimit =  customLimit ? customLimit : 250;
        if (!count) {
            console.log(methodName + '() tried to check the record count but was not passed a count value. Please add paging if you need more records than ' + pageLimit + ' records.');
            return pageLimit;
        }
        if (count < 0) {
            console.log(methodName + '() tried to use a negative count of (' +count +') records but we are correcting it to ' + pageLimit + '. Please check your maths before you got here.');
            return pageLimit;
        }
        if (count > pageLimit) {
            console.log(methodName + '() tried to get more than (' +count +') records but we are limiting it to ' + pageLimit + '. Please add paging if you need more records.');
            return pageLimit;
        }
        console.log('handleHighCountsForEndpoints() returned a limit of ' + count);
        return count;
    }

    // generic method to get all records for a given entity, paged
    async getAllPaged(entity, filter, scope?, errorHandler?, size?, queryString?) {
        scope = !!scope ? scope : entity;
        const pageSize = size || 250;
        const filterBase = filter.replace(/~FSF~.*$/, ''); // Remove sort clause for count
        const count = await this.getTotalCount(entity, `/FilteredTo/${filterBase}`, null, queryString ? (queryString + '&parallel=true') : '?parallel=true');
        const handler = errorHandler || this.logOnlyErrorHandler.bind(this, `getAllPaged:${entity}`, []);
        let allResults = [];
        const promiseSet = [];
        for (let offset = 0; offset < count; offset += pageSize) {
            const query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}${ queryString ? (queryString + '&parallel=true') : '?parallel=true' }`;
            promiseSet.push(new Promise((resolve, reject) => 
            {
                this.stub.do('get', entity, query, undefined, scope).then((results) =>
                {
                    if (results && !results.hasOwnProperty('Error')) {
                        return resolve(results);
                    }
                    resolve([]);
                }).catch(handler);
            }));
        }
        await Promise.all(promiseSet);
        for (let r of promiseSet)
        {
            const result = await r;
            if (result instanceof Array)
            {
                allResults = allResults.concat(result);
            }
        }
        return allResults;
    }

    async checkSessionForInternetConnectionStatus(loadingCtrl, device, navCtrl, toastCtrl) {
        // create loading spinner
        let loader = loadingCtrl.create({
            content: 'Loading...',
            duration: 3000
        });
        // check the wifi/auth for iOS devices to make sure we still have internet connection
        if (device.platform &&
            device.platform !== 'browser' &&
            device.platform !== null &&
            this.network.type !== 'none' &&
            window.localStorage.getItem('afterlogin') !== 'done'
        ) {
            // load the spinner
            loader.present();
            await this.checkForSessionConnectionError()
                .then(res => {
                    if (res == 'loginFail') {
                        // call failed, so let's notify the users
                        const toast = toastCtrl.create({
                            message: 'Athentication Failed. Please try to login again.',
                            duration: 5000
                        })
                        toast.present();
                        // no connection, back to the login page
                        navCtrl.setRoot('LoginPage');
                    }
                })
                .catch(e => {
                    // call failed, so let's notify the users
                    const toast = toastCtrl.create({
                        message: 'Server error: ' + e,
                        duration: 5000
                    })
                    toast.present();
                    // error, back to the login page
                    navCtrl.setRoot('LoginPage');
                });
            // let us know we are 'done'
            window.localStorage.setItem('afterlogin', 'done');
            // remove spinner
            if (loader) {
                loader.dismiss();
            }
        }
        // make sure to remove the spinner if we take too long
        setTimeout(() => {
            if (loader) {
                loader.dismiss();
            }
        }, 3000);
    }

    /**
     * Log a failed request and rethrow it with its cause intact.
     *
     * Bound two ways: `.catch(this.standardErrorHandler.bind(this))`, where the rejection arrives
     * as the first argument, and `.bind(this, 'name')`, where it arrives second. The old shape
     * treated the first as always the name, so the common form threw `new Error(undefined)` - a
     * blank "Error" with the real cause only in the log line above it - and never recognised a
     * dead session.
     *
     * @param {any} pOperationOrError The operation name, or the rejection when bound without one.
     * @param {Array<any>} pRest The rejection, when an operation name was bound.
     * @return {Promise<never>}
     */
    async standardErrorHandler(pOperationOrError: any, ...pRest: Array<any>): Promise<never> {
        const tmpNamed = pRest.length > 0;
        const tmpOperation = tmpNamed ? String(pOperationOrError) : 'request';
        const tmpError = tmpNamed ? pRest[0] : pOperationOrError;
        this.logOnlyErrorHandler(tmpOperation, null, tmpError);
        if (tmpError instanceof Error) {
            throw tmpError;
        }
        throw new Error(typeof tmpError === 'string' ? tmpError : JSON.stringify(tmpError));
    }

    async logOnlyErrorHandler(operationName: string, returnVal: any, error: any) {
        const tmpText = (error instanceof Error) ? error.message : (typeof error === 'string' ? error : JSON.stringify(error));
        if (tmpText === 'not logged in' || /not logged in/i.test(String(tmpText))) {
            this.events.publish('user:loggedOut', '');
        }
        console.error(`[${operationName}] Error:`, error);
        return returnVal;
    }

    async checkForSessionConnectionError() {
        console.log("environment: " + ENV.mode);
        console.log("network:" + this.network.type);

        if (this.network.type !== 'NONE') {
            let isLoggedIn = await this.authService.checkSession();
            if (isLoggedIn['LoggedIn']) {
                return false;
            } else {
                console.log('no logging in.');
                return 'loginFail';
            }

        } else {
            console.log('no internet connection');
        }
    }

    getTempSession() {
        return this.stub.do('get', 'CheckoutSessionToken', undefined, undefined, 'TempSession')
            .then((sessionToken: any) => {
                console.log(sessionToken);
                return sessionToken;
            });

    }

    replaceErrors(key, value) {
        if (value instanceof Error) {
            var error = {};

            Object.getOwnPropertyNames(value).forEach(function (propertyName) {
                error[propertyName] = value[propertyName];
            });

            return error;
        }
        return value;
    }

    async getProjectsPaged(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'getProjects';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        var query = filter ? `/LiteExtended/ExternalProjectID/FilteredTo/${filter}/${offset}/${pageSize}` : `/Lite/${offset}/${pageSize}`;
        return this.stub.do('get', 'Projects', query, undefined, scope).catch(this.logOnlyErrorHandler.bind(this, 'getProjectsPaged', []));
    }

    async getUsersPaged(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'getUsers';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        var query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}`;
        return this.stub.do('get', 'UserSelect', query, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async checkPlants(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'checkPlants';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        var query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}`;
        return this.stub.do('get', 'ProductionPlants', query, undefined, scope).catch(this.logOnlyErrorHandler.bind(this, 'checkPlants', []));
    }

    async checkLineitems(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'getLineItems';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        var query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}`;
        return new Promise((resolve, reject) => {
            this.stub.do('get', 'LineItems', query, undefined, scope)
                .then((lineitems) => {
                    resolve(lineitems);
                }, (error) => {
                    console.error('server connection error!', error);
                    resolve([]);
                });
        });
    }

    // hold the promise for the customer data
    customerDataPromise;

    async getCustomerData(id) {
        this.customerDataPromise = this.stub.do('get', 'Customer', `/${id}`)
            .then((customer) => {
                return customer;
            });
        return this.customerDataPromise;
    }

    async checkMaterials(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'Materials';
        var query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}`;
        return this.stub.do('get', 'Materials', query, undefined, scope)
            .then((materials) => {
                // temporary hack to modify GUIDs
                materials = _.map(materials, (mat) => {
                    mat.GUIDMaterial = mat.GUIDMaterial.replace('LADOTD-Material-', '');
                    return mat;
                });
                const orderedMaterials = _.orderBy(materials, ['CategoryName', 'IDMaterialParent', 'Name']);
                console.log(`checkMaterials(): returned ${orderedMaterials.length} material(s)`);
                return orderedMaterials;
            })
            .catch(this.logOnlyErrorHandler.bind(this, 'checkMaterials', []));
    }

    async getDistinctSampleStatuses(filter, scope?) {
        scope = scope || 'Samples';
        const query = `/Distinct/Status/FilteredTo/${filter}`;
        return this.stub.do('get', 'Samples', query, scope).catch(this.logOnlyErrorHandler.bind(this, 'getDistinctSampleStatuses', []));
    }

    async checkLabs(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'Labs';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        var query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}`;
        return this.stub.do('get', 'Labs', query, undefined, scope).catch(this.logOnlyErrorHandler.bind(this, 'checkLabs', []));
    }

    async getAllLabs(filter, scope?) {
        return this.getAllPaged('Labs', filter, scope);
    }

    async checkLabMaterialAssignment(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'LabMaterialAssignments';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        var query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}`;
        return this.stub.do('get', 'LabMaterialAssignments/Lite', query, undefined, scope).catch(this.logOnlyErrorHandler.bind(this, 'checkLabMaterialAssignment', []));
    }

    // For
    // @params: newLog: Log
    async postLog(newLog) {
        delete newLog['IsSync'];
        return this.stub.do('post', 'SampleLog', '', newLog)
            .then(result => {
                console.log('post log success');
                let log = new Log(
                    Number(result['IDSampleLog']),
                    Number(result['CreatingIDUser']),
                    Number(result['CaptureLongitude']),
                    Number(result['CaptureLatitude']),
                    Number(result['UserLatitude']),
                    Number(result['UserLongitude']),
                    Number(result['IDSample']),
                    result['Notes'],
                    result['CaptureDate'],
                    result['UpdateDate'],
                    0,
                    0,
                    true,
                    result['ToStatus'],
                    result['FromStatus'])
                return log;
            })
            .catch(this.logOnlyErrorHandler.bind(this, 'postLog', {}));
    }

    async updateLog(newLog) {
        delete newLog['IsSync'];
        return this.stub.do('put', 'SampleLog', '', newLog)
            .then(result => {
                console.log('put log success');
                let log = new Log(
                    Number(result['IDSampleLog']),
                    Number(result['CreatingIDUser']),
                    Number(result['CaptureLongitude']),
                    Number(result['CaptureLatitude']),
                    Number(result['UserLatitude']),
                    Number(result['UserLongitude']),
                    Number(result['IDSample']),
                    result['Notes'],
                    result['CaptureDate'],
                    result['UpdateDate'],
                    0,
                    0,
                    true,
                    result['ToStatus'],
                    result['FromStatus'])
                    return log;
            })
            .catch(this.standardErrorHandler.bind(this));
    }

    async getLog(logId, scope?) {
        scope = !!scope ? scope : 'SampleLog';
        return this.stub.do('get', 'SampleLog', `/${logId}`, undefined, scope).catch(this.logOnlyErrorHandler.bind(this, 'getLog', {}));
    }

    async getLogsByIDSample(sampleId, scope?, count?) {
        scope = !!scope ? scope : 'SampleLogs';
        count = this.handleHighCountsForEndpoints(count, scope);
        return this.stub.do('get', 'SampleLogs', `/FilteredTo/FBV~IDSample~EQ~${sampleId}~FOP~0~(~0~FBV~Notes~NE~INFO~FBVOR~Notes~IN~0~FCP~0~)~0~FSF~Ordinal~ASC~0/0/${count}`, undefined, scope)
            .catch(this.standardErrorHandler.bind(this));
    }

    /**
     * Get the single most recent log for each of the given samples.
     *
     * "Newest log per sample" is a group-wise maximum, which a flat list endpoint cannot
     * express: one chatty sample can fill the whole row limit and starve the rest. So we
     * order globally by IDSampleLog DESC and loop -- each round re-asks only for the
     * samples we have not resolved yet, which strictly shrinks the set, so it terminates.
     *
     * Ordering is by IDSampleLog, NOT CaptureDate. CaptureDate is nullable (many writers
     * omit it -- integrations, LIMS Concierge) and lodash/MySQL sort nulls to the end,
     * which made a null-CaptureDate row win as "latest". IDSampleLog is the auto-increment
     * primary key: monotonic, never null, and the same criterion the LatestSampleByLog
     * view uses (MAX(IDSampleLog)).
     *
     * TODO: replace this loop with a single filtered read of the LatestSampleByLog view
     * (`LIMS/LatestSamples` + `FBL~IDSample~INN~<ids>`) once the view is fixed. The view
     * already computes the group-wise maximum server-side and returns exactly one row per
     * sample -- no loop, no over-fetch. It is unusable for this today because its subquery
     * takes the latest log of ANY kind and the outer WHERE then requires a status change,
     * so any sample whose newest log is a non-status row (a Concierge audit entry, a plain
     * note) drops out entirely. Fix is written and shelved at
     * lib/headlight_model/schema/migrate-once/024/UpdateLatestSampleByLogView.sql in the
     * headlight monorepo. See docs/sample_info_bar_triage.md.
     *
     * @param {number[]} sampleIdList - sample IDs to resolve
     * @param {string} [scope] - request scope for the stub's request map
     * @param {number} [count] - rows per round; capped by handleHighCountsForEndpoints
     * @return {Promise<any[]>} at most one log per sample, that sample's newest
     */
    async getLatestLogsByIDSamples(sampleIdList, scope?, count?) {
        scope = !!scope ? scope : 'SampleLogs';
        const tmpPageLimit = this.handleHighCountsForEndpoints(count || LATEST_LOG_ROWS_PER_ROUND, scope);
        // INFO logs are bookkeeping, not activity. Excluded in the QUERY rather than after
        // the fact so the row limit and ordering stay meaningful -- and so a sample whose
        // only logs are INFO returns nothing and settles, instead of coming back every
        // round and never resolving. Same fragment (and OR-null half, see #469) as
        // getLogsByIDSample().
        const tmpNotesFilter = 'FOP~0~(~0~FBV~Notes~NE~INFO~FBVOR~Notes~IN~0~FCP~0~)~0';
        const tmpLatestBySample = {};
        let tmpPending = _.uniq(_.filter(sampleIdList, (id) => !!id));
        let tmpRounds = 0;

        while (tmpPending.length && tmpRounds < LATEST_LOG_MAX_ROUNDS) {
            tmpRounds++;
            const tmpQuery = `/FilteredTo/FBL~IDSample~INN~${tmpPending.join()}~${tmpNotesFilter}~FSF~IDSampleLog~DESC~0/0/${tmpPageLimit}`;
            const tmpLogs = await this.stub.do('get', 'SampleLogs', tmpQuery, undefined, `${scope}_${tmpRounds}`)
                .catch(this.logOnlyErrorHandler.bind(this, 'getLatestLogsByIDSamples', []));

            if (!Array.isArray(tmpLogs) || !tmpLogs.length) {
                break;
            }
            // Rows arrive IDSampleLog DESC, so the FIRST row we see for a sample is its
            // newest -- anything later for that sample sorts below it by definition.
            _.each(tmpLogs, (l: any) => {
                if (!tmpLatestBySample.hasOwnProperty(l.IDSample)) {
                    tmpLatestBySample[l.IDSample] = l;
                }
            });
            // A short page means we exhausted every log for the pending set; anyone still
            // unresolved simply has none. Without this the loop would spin forever on
            // samples that have no logs at all, since they never appear in a response.
            if (tmpLogs.length < tmpPageLimit) {
                break;
            }
            tmpPending = _.filter(tmpPending, (id) => !tmpLatestBySample.hasOwnProperty(id));
        }

        const tmpResolved = _.values(tmpLatestBySample);
        console.log(`getLatestLogsByIDSamples() resolved ${tmpResolved.length}/${_.uniq(sampleIdList).length} samples in ${tmpRounds} request(s)`);
        return tmpResolved;
    }

    async upsertSample(newSample: Sample) {
        delete newSample['IsSync']
        return this.stub.do(newSample.IDSample ? 'put' : 'post', 'Sample', '', newSample).catch(this.standardErrorHandler.bind(this));
    }

    async deleteItem(itemType, itemId) {
        return this.stub.do('delete', itemType, `/${itemId}`).catch(this.logOnlyErrorHandler.bind(this, 'deleteItem', { Count: 0 }));
    }

    async putSampleLocation(idSample, captureLatitude, captureLongitude) {
        let data = {
            "IDSample": idSample,
            "CaptureLatitude": captureLatitude,
            "CaptureLongitude": captureLongitude
        }
        console.log('DATA IN PUTSAMPLELOCATION', data)
        return this.stub.do('put', 'Sample', '', data).catch(this.standardErrorHandler.bind(this));
    }

    async getSampleById(IDSample, scope?) {
        scope = !!scope ? scope : 'Sample';
        return this.stub.do('get', 'Sample', `/${IDSample}`, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async getSampleByQR(QRCode, scope?) {
        scope = !!scope ? scope : 'Samples';
        if (!scope) {
            scope = 'getSampleByQR';
        }
        return this.stub.do('get', 'Samples', `/FilteredTo/FBV~QRCode~EQ~${encodeURIComponent(QRCode)}/0/1`, undefined, scope)
            .then((data: any) => {
                return Array.isArray(data) ? data[0] : [];
            })
            .catch(this.standardErrorHandler.bind(this));
    }

    async getTotalCount(entity, filter?, scope?, queryString?) {
        scope = !!scope ? `${scope}` : `${entity}|getTotalCount`;
        var query = filter ? filter : '';
        return this.stub.do('get', entity, '/Count' + query + (queryString || ''), undefined, scope)
            .then((res: any) => {
                return res && res.Count ? res.Count : 0;
            })
            .catch(this.logOnlyErrorHandler.bind(this, 'getTotalCount', 0));
    }

    async getSampleLogs(filter, scope?) {
        scope = !!scope ? scope : 'getSampleLogs';
        var query = (filter ? `/FilteredTo/${filter}` : '');
        return this.stub.do('get', 'SampleLogs', query, undefined, scope).catch(this.logOnlyErrorHandler.bind(this, 'getSampleLogs', []));
    }

    async getSamples(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'getSamples';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        var query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}`;
        return this.stub.do('get', 'Samples', query, undefined, scope).catch(this.logOnlyErrorHandler.bind(this, 'getSamples', []));
    }

    async getLatestSamplesByLog(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'getLatestSamplesByLog';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        const paginationClause = offset >= 0 && pageSize > 0 ? `/${offset}/${pageSize}`: '';
        const query = (filter ? `/FilteredTo/${filter}` : '') +  paginationClause;
        return this.stub.do('get', 'LIMS/LatestSamples', query, undefined, scope).catch(this.logOnlyErrorHandler.bind(this, 'getLatestSamplesByLog', []));
    }

    async getLatestSamplesByLogCount(filter?) {
        const scope =  `LatestSamples|getTotalCount`;
        const query = filter ? filter : '';
        return this.stub.do('get', 'LIMS/LatestSamples/Count', query, undefined, scope)
            .then((res: any) => {
                return res && res.Count ? res.Count : 0;
            })
            .catch(this.logOnlyErrorHandler.bind(this, 'getLatestSamplesByLogCount', 0));
    }

    async getProject(id, scope?) {
        scope = !!scope ? scope : 'getProject';
        return this.stub.do('get', 'Projects', `/LiteExtended/ExternalProjectID/FilteredTo/FBV~IDProject~EQ~${id}/0/1`, undefined, scope)
            .then((data) => {
                let project = {};
                if (data && !data.hasOwnProperty('Error')) {
                    //console.log("get project success");
                    if (Array.isArray(data) && data.length) {
                        let result = data[0];
                        project = new Project(result['IDProject'], result['IDContract'], result['Value'], result['ExternalProjectID'] || '');
                    }
                }
                return project;
            })
            .catch(this.standardErrorHandler.bind(this));
    }

    async getLineitem(id, scope?) {
        scope = !!scope ? scope : 'getLineItem';
        return this.stub.do('get', 'LineItem', `/${id}`, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    // we delete the join, then create a new join (not update the server with a POST)
    async updateSampleLineItemJoin(sampleId, lineItem) {
        if (!lineItem || !lineItem.hasOwnProperty('IDSampleLineItemJoin')) {
            console.log('no IDSampleLineItemJoin id found, cannot update:', lineItem);
            return;
        }
        let dataObject = {
            IDSample: lineItem.IDSample,
            IDLineItem: lineItem.IDLineItem,
            IDSampleLineItemJoin: lineItem.IDSampleLineItemJoin,
            RepresentedQuantity: lineItem.RepresentedQuantity,
            GUIDSampleLineItemJoin: lineItem.GUIDSampleLineItemJoin
        };
        this.sampleLineItemsJoins(dataObject, 'put');
    }

    async createSampleLineItemJoins(sampleId, lineItemId, RepresentedQuantity?) {
        let dataObject = {
            IDSample: sampleId,
            IDLineItem: lineItemId,
            IDSampleLineItemJoin: 0,
            RepresentedQuantity: RepresentedQuantity || '0.00'
        };
        this.sampleLineItemsJoins(dataObject, 'post');
    }

    async sampleLineItemsJoins(dataObject, action){
        return this.stub.do(action, 'SampleLineItemJoin', ``, dataObject).catch(this.standardErrorHandler.bind(this));
    }

    async deleteSampleLineItemJoin(id) {
        return this.stub.do('delete', 'SampleLineItemJoin', `/${id}`).catch(this.standardErrorHandler.bind(this));
    }

    async postSampleLabJoin(sampleId, labId) {
        console.log('postSampleLabJoin', sampleId, labId);
        let dataObject = {
            IDSample: sampleId,
            IDLab: labId
        };
        return this.stub.do('post', 'SampleLabJoin', ``, dataObject).catch(this.standardErrorHandler.bind(this));
    }

    async deleteSampleLabJoin(id) {
        return this.stub.do('delete', 'SampleLabJoin', `/${id}`).catch(this.logOnlyErrorHandler.bind(this, 'deleteSampleLabJoin', { Count: 0 }));
    }

    async getSampleLabJoins(sampleId, scope?) {
        scope = !!scope ? scope : 'getSampleLabJoins';
        return this.stub.do('get', 'SampleLabJoins', `/By/IDSample/${sampleId}/0/100`, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async getMaterialPayItemJoins(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'getMaterialPayItemJoins';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        var query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}`;
        return this.stub.do('get', 'MaterialPayItemJoins', query, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async getPayItemById(payItemId, scope?) {
        scope = !!scope ? scope : 'getPayItemById';
        return this.stub.do('get', 'PayItem', `/${payItemId}`, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async getSampleLineItemJoins(sampleId, scope?) {
        scope = !!scope ? scope : 'getSampleLineItemJoins';
        return this.stub.do('get', 'SampleLineItemJoins', `/By/IDSample/${sampleId}/0/100`, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    /**
     * Generic GET against an endpoint.
     *
     * `scope` names the endpoint AND, by default, the stub's in-flight request key. That key is
     * shared: starting a GET cancels any in-flight GET with the same key, and the cancelled one is
     * abandoned rather than rejected, so whoever was awaiting it waits forever. Two components
     * hitting the same endpoint concurrently is therefore enough to hang one of them.
     *
     * Pass pRequestScope to give a call site its own key when it can overlap another consumer of
     * the same endpoint — the same separation getLabTestDefaults already makes.
     *
     * @param {string} query The query/path suffix.
     * @param {string} [scope] The endpoint name; also the request key unless pRequestScope is given.
     * @param {string} [pRequestScope] A distinct in-flight request key for this call site.
     * @return {Promise<any>} The response, or [] on error.
     */
    async gopher(query, scope?, pRequestScope?) {
        scope = !!scope ? scope : 'MixSpecification';
        const tmpRequestScope = pRequestScope || scope;
        return this.stub.do('get', scope, query, undefined, tmpRequestScope).catch(this.logOnlyErrorHandler.bind(this, 'gopher', []));
    }

    async getLab(id, scope?) {
        scope = !!scope ? scope : 'getLab';
        return this.stub.do('get', 'Lab', `/${id}`, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async getLabsByIDs(filter, scope?) {
        scope = !!scope ? scope : 'getLabsByIDs';
        var query = `/FilteredTo/${filter}`;
        return this.stub.do('get', 'Labs', `/${query}`, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async getLabTestDefaults (filter, scope?) {
        scope = !!scope ? scope : 'getLabTestDefaults';
        var query = filter ? `/FilteredTo/${filter}/` : ``;
        return this.stub.do('get', 'LabTestDefaults', query, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async getAllLabTestDefaults(filter, scope?) {
        return this.getAllPaged('LabTestDefaults', filter, scope, this.standardErrorHandler.bind(this, 'getAllLabTestDefaults'));
    }

    async getTestsByTestIdList(testIds, scope?) {
        scope = !!scope ? scope : 'getTestsByTestIdList';
        return this.stub.do('get', 'Tests', `/FilteredTo/FBL~IDTest~INN~${testIds.join(',')}/0/${testIds.length}`, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async createTestInstance(testId, projectId, customerId, materialId, name, labId) {
        let dataObject = {
            IDCustomer: customerId,
            IDProject: projectId,
            IDTest: testId,
            IDMaterial: materialId,
            Name: name,
            IDLab: labId
        };
        return this.stub.do('post', 'TestInstance', ``, dataObject).catch(this.standardErrorHandler.bind(this));
    }

    async updateTestInstanceLab(IDTestInstance, labId) {
        let dataObject = {
            IDTestInstance: IDTestInstance,
            IDLab: labId
        };
        return this.stub.do('put', 'TestInstance', ``, dataObject).catch(this.standardErrorHandler.bind(this));
    }

    async deleteTestInstance(IDTestInstance) {
        return this.stub.do('delete', 'TestInstance', `/${IDTestInstance}`).catch(this.logOnlyErrorHandler.bind(this, 'deleteTestInstance', { Count: 0 }));
    }
    async deleteTestInstanceSampleJoin(IDTestInstanceSampleJoin) {
        return this.stub.do('delete', 'TestInstanceSampleJoin', `/${IDTestInstanceSampleJoin}`).catch(this.logOnlyErrorHandler.bind(this, 'deleteTestInstanceSampleJoin', { Count: 0 }));
    }

    async createTestInstanceSampleJoin(sampleId, testInstanceId) {
        let dataObject = {
            IDSample: sampleId,
            IDTestInstance: testInstanceId
        };
        return this.stub.do('post', 'TestInstanceSampleJoin', ``, dataObject).catch(this.standardErrorHandler.bind(this));
    }

    async getTestInstancesById(testInstanceIds, scope?) {
        scope = !!scope ? scope : 'getTestInstancesById';
        if (!testInstanceIds || !testInstanceIds.length) {
            return [];
        }
        // chunked to keep the INN list from overflowing the request line
        let allResults = [];
        for (let idChunk of _.chunk(testInstanceIds, 250)) {
            let chunkResults: any = await this.stub.do('get', 'TestInstances', `/FilteredTo/FBL~IDTestInstance~INN~${idChunk.join(',')}/0/${idChunk.length}`, undefined, scope).catch(this.standardErrorHandler.bind(this));
            if (Array.isArray(chunkResults)) {
                allResults = allResults.concat(chunkResults);
            }
        }
        return allResults;
    }

    // by Sample ID
    async getTestInstanceSampleJoinsBySampleId(sampleId, scope?, count?) {
        scope = !!scope ? scope : 'getTestInstanceSampleJoinsBySampleId';
        const pageSize = count || 250;
        const maxPages = 20;
        const filter = `/FilteredTo/FBL~IDSample~EQ~${sampleId}~`;
        let allResults = [];
        for (let page = 0; page < maxPages; page++) {
            let pageResults: any = await this.stub.do('get', 'TestInstanceSampleJoins', `${filter}/${page * pageSize}/${pageSize}`, undefined, scope).catch(this.standardErrorHandler.bind(this, scope));
            if (!Array.isArray(pageResults) || !pageResults.length) {
                return allResults;
            }
            allResults = allResults.concat(pageResults);
            if (pageResults.length < pageSize) {
                return allResults;
            }
        }
        console.error(`[${scope}] stopped paging sample ${sampleId} at ${maxPages * pageSize} test instance joins.`);
        return allResults;
    }

    async getUserNameById(userId) {
        return this.stub.do('get', 'User', `/${userId}`).catch(this.logOnlyErrorHandler.bind(this, 'getUserNameById', {}));
    }

    // Forms & Reports
    storedRNIs = [];
    storedRNIPromise;

    getReportNamedInstances(customerID, projectID?) {
        // get by customer
        let endpoint = projectID ? 'ReportNamedInstancesByProject' : 'ReportNamedInstances';
        let filterString =  projectID ? `/${projectID}/0/100` : `/FilteredTo/FBV~IDCustomer~EQ~${customerID}`;
        console.log('Getting reports by:', endpoint);

        return this.stub.do('get', endpoint, filterString)
            .then((reportInstances: any) => {
                if (reportInstances && !reportInstances.Error) {
                    this.storedRNIs = reportInstances;
                }
                return reportInstances;
            })
            .catch(this.standardErrorHandler.bind(this));
    }

    async getDocuments(filter, offset, pageSize, scope?) {
        scope = !!scope ? scope : 'getDocuments';
        pageSize = this.handleHighCountsForEndpoints(pageSize, scope);
        var query = (filter ? `/FilteredTo/${filter}` : '') + `/${offset}/${pageSize}`;
        return this.stub.do('get', 'Documents', query, undefined, scope).catch(this.standardErrorHandler.bind(this));
    }

    async createReport(documentData, scope?) {
            // Create new document for ID
        return this.stub.do('post', 'Document', undefined, documentData, scope || 'CreateDocument').catch(this.standardErrorHandler.bind(this));
    }

    async updateReport(documentData, scope?) {
        return this.stub.do('put', 'Document', undefined, documentData, scope || 'UpdateDocument').catch(this.standardErrorHandler.bind(this));
    }

    async renderReportByID(reportId, scope?) {
        scope = !!scope ? scope : 'getDocuments';
        return this.stub.do('get', 'Report/Render', `/${reportId}/default`, undefined, scope).catch(this.logOnlyErrorHandler.bind(this, 'renderReportByID', {}));
    }

    async createDocumentSampleJoin(documentId, samples, logs?, observations?) {
        // NOTE - we are passing in objects (samples, logs, observations) so make sure to strip out any unexpected attrs before getting here
        let model = {
            IDDocument: documentId,
            Observations: observations ? (Array.isArray(observations) ? observations : [observations]) : [],
            Samples: samples ? (Array.isArray(samples) ? samples : [samples]) : [],
            SampleLogs: logs ? (Array.isArray(logs) ? logs : [logs]) : [],
        };
        return this.stub.do('post', 'Document', `/FormProcessor`, model).catch(this.logOnlyErrorHandler.bind(this, 'createDocumentSampleJoin', {}));
    }

    async getDocumentsListBySampleId(sampleId, scope?, count?) {
        scope = !!scope ? scope : 'getDocumentsBySampleId';
        count = this.handleHighCountsForEndpoints(count, scope);
        return this.stub.do('get', 'DocumentPolyJoins', `/FilteredTo/FBV~RemoteType~EQ~Sample~FBV~IDRemote~EQ~${sampleId}/0/${count}`)
            .then(async (data) => {
                if (Array.isArray(data)) {
                    const docIdList = _.map(data, d=> d.IDDocument);
                    if (docIdList.length < 1) {
                        return [];
                    }
                    return this.getDocuments(`FBL~IDDocument~INN~${docIdList.join()}`, 0, docIdList.length);
                }
            })
            .catch(this.logOnlyErrorHandler.bind(this, 'getDocumentsListBySampleId', []));
    }
};



// WEBPACK FOOTER //
// ./src/providers/sync-server-service/sync-server-service.ts